import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Spinner from "../../components/shared/Spinner/Spinner";
import { FaFileExport, FaFilePdf, FaFileExcel } from "react-icons/fa";
import $axios from "../../api/accessor";
import { $api } from "../../api/api";
import { Table, Input, Button, Dropdown, message, Popconfirm } from "antd";
import { ColumnsType } from "antd/es/table";
import type { MenuProps } from "antd";

interface SubscribeDataType {
  id: number;
  email: string;
  created_at: string;
  updated_at: string;
}

const Subscribe = () => {
  const [subscribeData, setSubscribeData] = useState<SubscribeDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("az-AZ", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await $axios.get($api("subscribe"));
      setSubscribeData(response.data.data);
    } catch (error) {
      console.log(error);
      message.error("Məlumatlar yüklənərkən xəta baş verdi!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id: number) => {
    try {
      await $axios.delete($api(`subscribe/${id}`));
      message.success("Abunə uğurla silindi!");
      fetchData();
    } catch (error) {
      message.error("Silinərkən xəta baş verdi!");
      console.error(error);
    }
  };

  const columns: ColumnsType<SubscribeDataType> = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      width: 80,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Qeydiyyat tarixi",
      dataIndex: "created_at",
      key: "created_at",
      render: (date: string) => formatDate(date),
      sorter: (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
    },
    {
      title: "Yenilənmə tarixi",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (date: string) => formatDate(date),
      sorter: (a, b) =>
        new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime(),
    },
    {
      title: (
        <div className="settings">
          <i className="fa-solid fa-gear"></i>
        </div>
      ),
      key: "action",
      width: 100,
      render: (_, record) => (
        <div className="settings_icons">
          <Popconfirm
            title="Bu abunəni siləcəyinizə əminsiniz?"
            onConfirm={() => handleDelete(record.id)}
            onCancel={() => message.info("Silmə əməliyyatı ləğv edildi.")}
            okText="Bəli"
            cancelText="Xeyr"
            placement="topRight"
          >
            <div className="delete">
              <i className="fa-solid fa-trash"></i>
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div id="pages">
      <Helmet>
        <title>Orhan Door | Abunələr</title>
      </Helmet>

      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div className="page_head">
            <h3 className="page_title">Abunə Olanlar</h3>
          </div>

          <div className="pages_components">
            <div className="pages_table">
              <Table<SubscribeDataType>
                scroll={{ x: "100%" }}
                columns={columns}
                dataSource={subscribeData}
                rowKey={(record) => record.id.toString()}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscribe;
